import Vue from 'vue'
import configs from '@/config'
import { decryptAndParse } from '@/utils/decrypt.util'
import { captureException } from '@sentry/vue'

let resource = null

const actions = {
  getSlides: {
    method: 'GET',
    url: `${configs.baseUrl}/api/presentation/audience-presentation-slide-list/{presentationId}`,
  },
  asyncAudienceLeaderboard: {
    method: 'POST',
    url: `${configs.baseUrl}/api/slide/async-create-leaderboard/`,
  },
  getNextSlide: {
    method: 'GET',
    url: `${configs.baseUrl}/api/presentation/next-slide/{slideId}`,
  },
  getSlideDetailV2: {
    method: 'GET',
    url: `${configs.baseUrl}/api/v2/slides/{slideId}`,
  },
  getSlideEmbed: {
    method: 'GET',
    url: `${configs.baseUrl}/api/slide/embed/{slideId}`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const getSlides = async (presentationId) => {
  const res = await resource.getSlides({ presentationId })

  return res.body
}

const getNextSlide = async (slideId) => {
  return resource.getNextSlide({ slideId })
}

const getSlideDetailV2 = async (slideId, encrypted = false) => {
  const res = await resource.getSlideDetailV2({
    slideId,
    ...(encrypted ? { encrypted } : {}),
  })
  if (encrypted) {
    // try to decode the data here
    try {
      return decryptAndParse(res.body.encrypted, slideId)
    } catch (err) {
      // in case of error, return the original response
      captureException(err)
    }
  }
  return res.body
}

const asyncAudienceLeaderboard = async (params) => {
  const res = await resource.asyncAudienceLeaderboard(params)
  return res.body
}

const getSlideEmbed = async (slideId) => {
  const res = await resource.getSlideEmbed({ slideId })
  return res.body
}

export default {
  initResource,
  getSlides,
  asyncAudienceLeaderboard,
  getNextSlide,
  getSlideDetailV2,
  getSlideEmbed,
}
